import React, { useEffect, useRef } from "react";
export function SkeletonSize({ setEstimatedSize, children, className = "" }) {
    const ref = useRef(null);
    // Observed, not measured once: a single read after a timeout missed any later
    // reflow (fonts loading, a width change re-wrapping the card) and never fired
    // at all when the element had no height yet at mount.
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const element = ref.current;
        const updateSize = () => {
            const height = element.clientHeight;
            if (height) {
                setEstimatedSize(height + 20);
            }
        };
        updateSize();
        const observer = new ResizeObserver(updateSize);
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [setEstimatedSize]);
    return (<div className={className} ref={ref}>
            {children}
        </div>);
}
//# sourceMappingURL=skeletonSize.jsx.map